import React, { ReactElement } from 'react';
import GridItem from '../grid-item/grid-item.component';
import FormatService from '../../services/format-service';
import useStylesGridItemCardViewBlock from './grid-item-card-view-block.styles';

const GridItemCardViewBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isCompressed,
    isExtraCompressed,
    className,
    children,
  } = props;

  const { classes } = useStylesGridItemCardViewBlock();

  const compressedClassName: string | undefined = isCompressed ? classes.gridItemCardViewBlockCompressed : undefined;
  const extraCompressedClassName: string | undefined = isExtraCompressed
    ? classes.gridItemCardViewBlockExtraCompressed : undefined;

  return (
    <GridItem
      className={FormatService.formatClassNames(
        classes.gridItemCardViewBlock, compressedClassName, extraCompressedClassName, className,
      )}
    >
      {children}
    </GridItem>
  );
});

export default GridItemCardViewBlock;
